const logger = require("../Logger");

let alreadyLoggedWarning = false;

const service = {};

service.logMemoryUsage = () => {
  const memoryDetail = {};

  const memoryPerformanceDataAvailable = performance && performance.memory;
  const deviceMemoryAvailable = navigator && navigator.deviceMemory;

  if( memoryPerformanceDataAvailable ) {
    memoryDetail.totalJSHeapSize = performance.memory.totalJSHeapSize;
    memoryDetail.usedJSHeapSize = performance.memory.usedJSHeapSize;
    memoryDetail.jsHeapSizeLimit = performance.memory.jsHeapSizeLimit;
  }

  if( deviceMemoryAvailable ) {
    memoryDetail.deviceMemory = navigator.deviceMemory;
  }

  if( memoryPerformanceDataAvailable || deviceMemoryAvailable ) {
    logger.viewerInfo("Memory Usage", JSON.stringify(memoryDetail));
  } else if( !alreadyLoggedWarning ) {
    logger.viewerWarning("Memory performance data and device memory not available");
    alreadyLoggedWarning = true;
  }
};

service.reset = () => {
  alreadyLoggedWarning = false;
};

module.exports = service;
